module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VG1007-bbe56e7a93fa06b2d85b8a176de1a148.png";